import { render, staticRenderFns } from "./TabsResource.vue?vue&type=template&id=4ae4091f&scoped=true"
import script from "./TabsResource.vue?vue&type=script&lang=ts"
export * from "./TabsResource.vue?vue&type=script&lang=ts"
import style0 from "./TabsResource.vue?vue&type=style&index=0&id=4ae4091f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae4091f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae4091f')) {
      api.createRecord('4ae4091f', component.options)
    } else {
      api.reload('4ae4091f', component.options)
    }
    module.hot.accept("./TabsResource.vue?vue&type=template&id=4ae4091f&scoped=true", function () {
      api.rerender('4ae4091f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/v2/TabsResource.vue"
export default component.exports